"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectToChannelAndDisconnect = exports.setThemeColorsFn = void 0;
var addons_1 = __importDefault(require("@storybook/addons"));
var config_1 = require("../dist/config");
exports.setThemeColorsFn = function (emit) { return function (colors) {
    emit(config_1.EVENT_SET_THEME, {
        themeColors: colors,
    });
}; };
exports.connectToChannelAndDisconnect = function (eventName, fn) {
    var channel = addons_1.default.getChannel();
    channel.on(eventName, fn);
    return function () { return channel.removeListener(eventName, fn); };
};
